"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordRequestSchema = exports.UserListResponseSchema = exports.UserListQuerySchema = exports.UserDetailSchema = exports.UserSummarySchema = void 0;
const zod_1 = require("zod");
const query_1 = require("./query");
exports.UserSummarySchema = zod_1.z.object({
    staffId: zod_1.z.number(),
    loginName: zod_1.z.string(),
    fullName: zod_1.z.string().nullable(),
    email: zod_1.z.string().nullable(),
    mobile: zod_1.z.string().nullable(),
    isEnabled: zod_1.z.boolean(),
    orgId: zod_1.z.number().nullable(),
    orgName: zod_1.z.string().nullable(),
    avatarPath: zod_1.z.string().nullable(),
    /* Hai cột lưới hệ cũ: "Mã nhân viên" và nửa dưới của "Phòng ban || Vai trò". */
    employeeCode: zod_1.z.string().nullable().default(null),
    roleName: zod_1.z.string().nullable().default(null),
});
exports.UserDetailSchema = exports.UserSummarySchema.extend({
    employeeId: zod_1.z.number().nullable(),
    position: zod_1.z.string().nullable(),
    roles: zod_1.z.array(zod_1.z.object({
        roleId: zod_1.z.number(),
        code: zod_1.z.string().nullable(),
        name: zod_1.z.string().nullable(),
        isDefault: zod_1.z.boolean(),
    })),
});
exports.UserListQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(200).default(50),
    q: zod_1.z.string().trim().optional(),
    orgId: zod_1.z.coerce.number().int().optional(),
    enabledOnly: query_1.QueryBoolean.default(true),
    /* Tám ô lọc của màn "Quản trị › Danh sách người dùng" bên hệ cũ. */
    fullName: zod_1.z.string().trim().optional(),
    employeeCode: zod_1.z.string().trim().optional(),
    email: zod_1.z.string().trim().optional(),
    phone: zod_1.z.string().trim().optional(),
    loginName: zod_1.z.string().trim().optional(),
    enabled: query_1.QueryBoolean.optional(),
    roleId: zod_1.z.coerce.number().int().optional(),
});
exports.UserListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.UserSummarySchema),
    total: zod_1.z.number(),
    page: zod_1.z.number(),
    pageSize: zod_1.z.number(),
});
exports.ChangePasswordRequestSchema = zod_1.z.object({
    currentPassword: zod_1.z.string().min(1).max(256),
    newPassword: zod_1.z.string().min(6).max(256),
});
